var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.6363 49.8691C84.6363 53.0598 81.8889 55.6464 78.4999 55.6464C77.7619 55.6464 77.0543 55.5237 76.3989 55.2989",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0088 65.4309L78.4447 70.8251L89.3165 60.0366C92.092 57.4193 93.7859 53.8272 93.7859 49.8338C93.7859 43.5382 89.5167 38.1818 83.5584 36.1965",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3641 49.8691C16.3641 53.0598 19.1115 55.6464 22.5006 55.6464C23.2386 55.6464 23.9462 55.5237 24.6016 55.2989",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9917 65.4309L22.5558 70.8251L11.684 60.0366C8.90848 57.4193 7.21455 53.8272 7.21455 49.8338C7.21455 43.5382 11.4838 38.1818 17.442 36.1965",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9079 92.9595C63.1614 93.2975 61.2876 93.5759 59.3148 93.7857M41.6857 93.7857C30.7073 92.6178 22.7974 89.3283 22.7974 85.4528C22.7974 82.4429 27.5682 79.7865 34.8421 78.2029M66.1584 78.2029C73.4322 79.7865 78.2031 82.4429 78.2031 85.4528C78.2031 86.7313 77.3421 87.9462 75.7941 89.042",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5288 62.2815C59.2156 69.6622 53.6075 75.7754 51.0424 78.4632C50.2643 79.2787 48.9916 79.2661 48.2444 78.4221C43.0106 72.5106 24.5283 50.5009 24.5283 34.4843C24.5283 19.4235 36.1899 7.21429 50.5752 7.21429C64.0078 7.21429 75.0655 17.8599 76.4712 31.5323M71.4944 51.229C72.3381 49.6385 73.1096 48.0383 73.7837 46.4448M76.1918 38.7901C76.1023 39.2613 75.9997 39.7357 75.8846 40.2127",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3513 33.1857C64.3513 40.8356 58.1498 47.0371 50.4999 47.0371C42.8499 47.0371 36.6484 40.8356 36.6484 33.1857C36.6484 25.5358 42.8499 19.3343 50.4999 19.3343",
    stroke: "#0098FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonsIcon);
export default __webpack_public_path__ + "static/media/PolygonsIcon.2a6ffa1cae09d9d30757ded1ed7afcad.svg";
export { ForwardRef as ReactComponent };